import { FC } from 'react'

import SafetyCasePopUpContent from '../safety-case-pop-up-content'

import { ISafetyCase } from '../../../interfaces'

type SafetyCasePopupProps = {
  safetyCase?: ISafetyCase
  onNavigateToSafetyCase?: (safetyCase?: ISafetyCase) => void
}

const SafetyCasePopup: FC<SafetyCasePopupProps> = props => {
  const { safetyCase, onNavigateToSafetyCase } = props

  if (!safetyCase) {
    return null
  }

  return (
    <>
      <div className="border-bottom text-center w-100 mb-2">
        <button
          className="btn btn-link p-0 text-decoration-none"
          onClick={() => onNavigateToSafetyCase?.(safetyCase)}
        >
          <h5>Safety Case #{safetyCase?.id}</h5>
        </button>
      </div>

      <SafetyCasePopUpContent safetyCase={safetyCase} />
    </>
  )
}

export default SafetyCasePopup
